// 把民國出生日期編成 URL 友善字串、再從字串解回，提供 QR Code 印製情境使用。
// 加密強度只到「混淆」等級：固定 key 做 XOR 後以 URL-safe base64 編碼。
// 範例：encodeBirthDate(105, 10, 10) -> "Yh1eXgEAAw" (實際值依 key 而定)

const XOR_KEY = 'kH9pZxQmN3'

const ROC_YEAR_MIN = 1
const ROC_YEAR_MAX = 115
const MONTH_MIN = 1
const MONTH_MAX = 12
const DAY_MIN = 1
const DAY_MAX = 31

function pad(n, width) {
  return String(n).padStart(width, '0')
}

function xor(input) {
  let out = ''
  for (let i = 0; i < input.length; i++) {
    out += String.fromCharCode(
      input.charCodeAt(i) ^ XOR_KEY.charCodeAt(i % XOR_KEY.length)
    )
  }
  return out
}

function toUrlSafeBase64(s) {
  return btoa(s).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

function fromUrlSafeBase64(s) {
  const restored = s.replace(/-/g, '+').replace(/_/g, '/')
  const padded = restored + '='.repeat((4 - (restored.length % 4)) % 4)
  return atob(padded)
}

export function encodeBirthDate(rocYear, month, day) {
  if (
    !Number.isInteger(rocYear) ||
    !Number.isInteger(month) ||
    !Number.isInteger(day) ||
    rocYear < ROC_YEAR_MIN ||
    rocYear > ROC_YEAR_MAX ||
    month < MONTH_MIN ||
    month > MONTH_MAX ||
    day < DAY_MIN ||
    day > DAY_MAX
  ) {
    throw new Error(
      `Invalid birth date: roc ${rocYear}/${month}/${day} (allowed roc ${ROC_YEAR_MIN}-${ROC_YEAR_MAX})`
    )
  }
  const digits = pad(rocYear, 3) + pad(month, 2) + pad(day, 2)
  return toUrlSafeBase64(xor(digits))
}

export function decodeBirthDate(encoded) {
  if (typeof encoded !== 'string' || encoded.length === 0) return null
  let digits
  try {
    digits = xor(fromUrlSafeBase64(encoded))
  } catch (e) {
    return null
  }
  if (!/^\d{7}$/.test(digits)) return null
  const rocYear = parseInt(digits.slice(0, 3), 10)
  const month = parseInt(digits.slice(3, 5), 10)
  const day = parseInt(digits.slice(5, 7), 10)
  if (
    rocYear < ROC_YEAR_MIN ||
    rocYear > ROC_YEAR_MAX ||
    month < MONTH_MIN ||
    month > MONTH_MAX ||
    day < DAY_MIN ||
    day > DAY_MAX
  ) {
    return null
  }
  return { rocYear, month, day }
}
